import { ChangeDetectionStrategy, booleanAttribute, Component, input, model, output } from "@angular/core";
import { StrategyEx } from "@front/m19-models";
import {
  IButtonDirective,
  IDateAggreationSwitchComponent,
  ISwitchButtonComponent,
  IToggleComponent,
  Option,
  SwitchButtonType,
  IIconComponent,
  SpinnerComponent,
} from "@front/m19-ui";
import { DateAggregation } from "@front/m19-utils";
import { TranslocoDirective } from "@jsverse/transloco";
import { ActivityEventFiltersComponent } from "@m19-board/activity-event-filters.component";
import { ActivityEventType } from "@m19-board/activities/activity-event-annotations.service";

@Component({
  selector: "app-chart-layout",
  imports: [
    TranslocoDirective,
    IButtonDirective,
    ActivityEventFiltersComponent,
    IToggleComponent,
    IDateAggreationSwitchComponent,
    ISwitchButtonComponent,
    IIconComponent,
    SpinnerComponent,
  ],
  templateUrl: "./chart-layout.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartLayoutComponent {
  readonly SwitchButtonType = SwitchButtonType;

  title = input<string | undefined>(undefined);
  closable = input(false, { transform: booleanAttribute });
  withDateAggregation = input(false, { transform: booleanAttribute });
  emptyData = input(false);
  dataLoading = input(false, { transform: booleanAttribute });
  withEventAnnotation = input(false, { transform: booleanAttribute });
  displayEventAnnotation = model(false);
  disableEventAnnotation = input(false);
  allEventAnnotationTypes = input<Option<ActivityEventType>[]>([]);
  allStrategies = input<Option<StrategyEx>[] | undefined>(undefined);
  chartDisplayModes = input<string[] | undefined>(undefined);
  selectedChartDisplayMode = input<string>();

  displayModeChange = output<string>();
  aggregationChange = output<DateAggregation>();
  closeClicked = output<void>();
}
